import { Account } from '../types'

export const getAccounts = (): Account[] => {
    return [
        {
            panId: 110394853,
            panNumber: '110394853',
        },
        {
            panId: 110394854,
            panNumber: '110394854',
        },
        {
            panId: 110394855,
            panNumber: '110394855',
        },
        {
            panId: 110394856,
            panNumber: '110394856',
        },
    ]
}
